// extracted by css-extract-rspack-plugin
export default {"RefSelectorTabs":"RefSelector-module__RefSelectorTabs__j_8pE"};